import { GREATER_THAN, LESS_THAN, MULT } from '../../constants';

export default {
  aPatternGoesXYThenItRepeatsDrawTheShapes:
    'A pattern goes: {0:string|lower}, {1:string|lower}, then it repeats.<br/>Draw the shapes to make the pattern.',
  aPatternGoesXYZThenItRepeatsDrawTheShapes:
    'A pattern goes: {0:string|lower}, {1:string|lower}, {2:string|lower}, then it repeats.<br/>Draw the shapes to make the pattern.',
  aToyCarIsHeavierThenXCubesButLighterThanYCubesTickAllTheMassesThatTheCarCouldBe:
    'A toy car is heavier than {0:number|numberFormat} cubes, but lighter than {1:number|numberFormat} cubes.<br/>Tick all the masses that the car could be.',
  canEachChildHave1AppleTickYourAnswer: 'Can each child have 1 apple?<br/>Tick your answer.',
  canEachChildHave1CakeTickYourAnswer: 'Can each child have 1 cake?<br/>Tick your answer.',
  canEachChildHave1CookieTickYourAnswer: 'Can each child have 1 cookie?<br/>Tick your answer.',
  canEachHorseHave1BaleOfHayTickYourAnswer:
    'Can each horse have 1 bale of hay?<br/>Tick your answer.',
  canEachHorseHave1CarrotTickYourAnswer: 'Can each horse have 1 carrot?<br/>Tick your answer.',
  canEachSheepHave1BaleOfHayTickYourAnswer:
    'Can each sheep have 1 bale of hay?<br/>Tick your answer.',
  charHasPoundsXHeSheSpendsMoneyOnAComicTickTheBoxThatShowsTheChangeCharGets:
    '{0} has £{1:number|numberFormat}<br/>{2} spends {3} on a comic.<br/>Tick the box that shows the change {0} gets.',
  characterIsCountingBackwardsFromXToYTickTheNumbersCharacterWillSay:
    '{character} is counting backwards from {numberA:number|numberFormat} to {numberB:number|numberFormat}<br/>Tick the numbers {character} will say.',
  characterIsCountingForwardsFromXToYTickTheNumbersCharacterWillSay:
    '{character} is counting forwards from {numberA:number|numberFormat} to {numberB:number|numberFormat}<br/>Tick the numbers {character} will say.',
  characterIsCountingForwardsInXFromYTickNumbers:
    '{0} is counting forwards in {1}s from {2}<br/>Tick the numbers in the counting sequence.',
  characterIsCountingBackwardsInXFromYTickNumbers:
    '{0} is counting backwards in {1}s from {2}<br/>Tick the numbers in the counting sequence.',
  circleAllOfTheShapesWithLessThanNumberVertices:
    'Circle all of the shapes with less than {0:number|numberFormat} vertices.',
  circleAllOfTheShapesWhatIsTheNamesOfTheShapesThatAreLeft:
    'Circle all of the {0:string|lower}.<br/>What is the name of the shapes that are left?',
  circleAllTheEvenNumbers: 'Circle all the even numbers.',
  circleAllTheOddNumbers: 'Circle all the odd numbers.',
  circleAllTheShape: 'Circle all the {0:string|lower}.',
  circleTheCoinsToMakeXP: 'Circle the coins to make {0:number|numberFormat}p.',
  circleTheCoinsToMakePoundX: 'Circle the coins to make £{0: number}',
  circleTheDiagramsThatShowAHalf: 'Circle the diagram{{s}} that show{{s|}} a half.',
  circleTheDiagramsThatShowAThird: 'Circle the diagram{{s}} that show{{s|}} a third.',
  circleTheDiagramsThatShowAQuarter: 'Circle the diagram{{s}} that show{{s|}} a quarter.',
  circleGreaterThanNumberAsWord: 'Circle a number that is greater than {0: string|lower}.',
  circleGreaterThanNumberAsNumber: 'Circle a number that is greater than {0: number}',
  circleLessThanNumberAsWord: 'Circle a number that is less than {0: string|lower}.',
  circleLessThanNumberAsNumber: 'Circle a number that is less than {0: number}',
  circleNumberAsWord: 'Circle {0: string|lower}.',
  circleNumberObject: 'Circle {0:number|numberFormat} {1:string|lower}.',
  circleOneLessThanNumberAsWord: 'Circle one less than {0: string|lower}.',
  circle1LessThanNumberAsNumber: 'Circle 1 less than {0: number}',
  circleOneMoreThanNumberAsWord: 'Circle one more than {0: string|lower}.',
  circle1MoreThanNumberAsNumber: 'Circle 1 more than {0: number}',
  circleTheGroupThatHasAXShaded: 'Circle the group that has a {0:string|lower} shaded.',
  circleTheGroupsThatHaveAXShaded: 'Circle the groups that have a {0:string|lower} shaded.',
  circleTheGroupThatShowsX: 'Circle the group that shows {0:string|lower}.',
  circleTheNameOfTheShapeDescribedInTheLabel:
    'Circle the name of the shape described in the label.',
  circleTheNumber1LessThanNum: 'Circle the number 1 less than {numberA:number|numberFormat}',
  circleTheNumber1MoreThanNum: 'Circle the number 1 more than {numberA:number|numberFormat}',
  circleTheNumberNum: 'Circle the number {numberA:number|numberFormat}',
  circleTheNumberSidedShapes: 'Circle the {0:number|numberFormat}-sided shapes.',
  circleTheOddOneOut: 'Circle the odd one out.',
  circleThePicturesThatHaveHalfShaded: 'Circle the pictures that have a half shaded.',
  circleThePicturesThatHaveQuarterShaded: 'Circle the pictures that have a quarter shaded.',
  circleThePicturesThatHaveThirdShaded: 'Circle the pictures that have a third shaded.',
  circleThePicturesThatHaveThreeQuartersShaded:
    'Circle the pictures that have three-quarters shaded.',
  circleTheShapeWithACurvedSurface: 'Circle the shape with a curved surface.',
  circleTheShapeWithNumEdges: 'Circle the shape with {0:number|numberFormat} edges.',
  circleTheShapeWithNumVertices: 'Circle the shape with {0:number|numberFormat} vertices.',
  circleTheShapesWithNumberVertices: 'Circle the shapes with {0:number|numberFormat} vertices.',
  circleTheShapesThatRoll: 'Circle the shapes that roll.',
  circleTheShapesWithACurvedSurface: 'Circle the shapes with a curved surface.',
  circleTheX: 'Circle the {0:string|lower}.',
  circleTheXThatAreCutInHalf: 'Circle the {0:string|lower} that are cut in half.',
  circleTheXThatIsCutInHalf: 'Circle the {0:string|lower} that is cut in half.',
  circleTheXThatAreCutIntoYEqualParts:
    'Circle the {0:string|lower} that are cut into {1:number|numberFormat} equal parts.',
  circleTheXThatIsCutIntoYEqualParts:
    'Circle the {0:string|lower} that is cut into {1:number|numberFormat} equal parts.',
  circleXLessThanY: 'Circle {0:number|numberFormat} less than {1}',
  circleXMoreThanY: 'Circle {0:number|numberFormat} more than {1}',
  circleXPoundsAndYPence: 'Circle £{0:number|numberFormat} and {1:number|numberFormat}p.',
  colourXCircles: 'Colour {0:number|numberFormat} circle{{s}}.',
  colourXSquares: 'Colour {0:number|numberFormat} square{{s}}.',
  completePictogram: 'Complete the pictogram.',
  completeTallyChart: 'Complete the tally chart.',
  completeTheBlockDiagram: 'Complete the block diagram.',
  completeTheSentence: 'Complete the sentence.',
  completeTheString: 'Complete the {0:string|lower}.',
  crossOutToShowTheBirdsThatFlewAway: 'Cross out to show the birds that flew away.',
  crossOutToShowCarsThatDriveAway: 'Cross out to show the cars that drive away.',
  crossOutToShowTheXFoodObjectThatWereEaten:
    'Cross out to show the {0:string|lower} that were eaten.',
  drawXLessThanY: 'Draw {0:number|numberFormat} less than {1}',
  drawXMoreThanY: 'Draw {0:number|numberFormat} more than {1}',
  drawACircleAboveTheShape: 'Draw a circle <b>above</b> the {0:string|lower}.',
  drawACircleBelowTheShape: 'Draw a circle <b>below</b> the {0:string|lower}.',
  drawACircleBetweenTheShapeAAndTheShapeB:
    'Draw a circle <b>between</b> the {0:string|lower} and the {1:string|lower}.',
  drawACircleDyTheShape: 'Draw a circle <b>{0:string|lower}</b> the {1:string|lower}.',
  drawACircleToTheDxTheShape: 'Draw a circle to the <b>{0:string|lower}</b> the {1:string|lower}.',
  drawAClosedShapeWithAVerticalLineOfSymmetry:
    'Draw a closed shape with a vertical line of symmetry.',
  drawALineToShowWhereTheWaterReaches: 'Draw a line to show where the water reaches.',
  drawAShapeWithNumVertices: 'Draw a shape with {0:number|numberFormat} vertices.',
  drawAnArrayToShowXMultY: `Draw an array to show {0:number|numberFormat} ${MULT} {1:number|numberFormat}`,
  drawAnArrowToShowWhereNumBelongsOnTheNumberLine:
    'Draw an arrow to show where {0:number|numberFormat} belongs on the number line.',
  drawArrowEstimateNumberIs: 'Draw an arrow to estimate where {0} is.',
  drawArrowEstimateNumberIsOnNumberLine:
    'Draw an arrow to estimate where {0} is on the number line.',
  drawAnArrowToEstimateWhereNumBelongsOnTheNumberLine:
    'Draw an arrow to estimate where {0:number|numberFormat} belongs on the number line.',
  drawArrowToShowTheMassOfXG: 'Draw an arrow to show the mass of {0:number|numberFormat} g.',
  drawArrowToShowTheMassOfXKg: 'Draw an arrow to show the mass of {0:number|numberFormat} kg.',
  drawArrowToShowTheTotalMass: 'Draw an arrow to show the total mass.',
  drawArrowToShowXCOnTheThermometer:
    'Draw an arrow to show {0:number|numberFormat} °C on the thermometer.',
  drawAShapeAboveTheShape: 'Draw a {0:string|lower} <b>above</b> the {1:string|lower}.',
  drawAShapeBelowTheShape: 'Draw a {0:string|lower} <b>below</b> the {1:string|lower}.',
  drawAShapeToTheLeftOfTheShape:
    'Draw a {0:string|lower} to the <b>left</b> of the {1:string|lower}.',
  drawAShapeToTheRightOfTheShape:
    'Draw a {0:string|lower} to the <b>right</b> of the {1:string|lower}.',
  drawBase10ToShowX: 'Draw base 10 to show {0}',
  drawBase10ToShowTheNumberX: 'Draw base 10 to show the number {0:number|numberFormat}',
  drawCountersOnTheTenFrameToMatchNumberOfObject:
    'Draw counters on to the ten frame to match the number of {0:string|lower}.',
  drawCountersToAddXMore: 'Draw counters to add {0:number|numberFormat} more.',
  drawCountersToMakeXEqualGroupsOfY:
    'Draw counters to make {0:number|numberFormat} equal groups of {1:number|numberFormat}',
  drawCountersToShowDoubleX: 'Draw counters to show double {0:number|numberFormat}',
  drawCountersToShowX: 'Draw counters to show {0}',
  drawLineThatIsXCmLong: 'Draw a line that is {0:number|numberFormat} cm long.',
  drawStraightLineToSplitTheShapeInHalf: 'Draw a straight line to split the shape in half.',
  drawTwoStraightLinesToSplitTheShapeIntoQuarters:
    'Draw two straight lines to split the shape into quarters.',
  drawCountersToMakeX: 'Draw counters to make {0}',
  drawCountersToShowHowManyXHas: 'Draw counters to show how many {0} has.',
  drawCountersToShowXLessThanY:
    'Draw counters to show {0:number|numberFormat} less than {1:number|numberFormat}',
  drawCountersToShowXMoreThanY:
    'Draw counters to show {0:number|numberFormat} more than {1:number|numberFormat}',
  drawBase10ToShowXMoreThanY:
    'Draw base 10 to make {0:number|numberFormat} more than {1:number|numberFormat}',
  drawBase10ToMakeXLessThanY:
    'Draw base 10 to make {0:number|numberFormat} less than {1:number|numberFormat}',
  drawBase10ToShowXLess:
    'Draw base 10 to show {0:number|numberFormat} less than {1:number|numberFormat}',
  drawBase10ToShowXMore:
    'Draw base 10 to show {0:number|numberFormat} more than {1:number|numberFormat}',
  drawHandsOnClockToShowX: 'Draw hands on the clock to show {0}',
  drawLinesToSortTheObjectsIntoTwoGroups: 'Draw lines to sort the objects into two groups.',
  drawCoinsToMakeNumP: 'Draw coins to make {0:number|numberFormat}p.',
  drawCoinsToMakeNumPounds: 'Draw coins to make £{0:number|numberFormat}',
  drawLinesToSortTheShapesIntoTwoGroups: 'Draw lines to sort the shapes into two groups.',
  drawMoneySoThatEachBoxHasNumP: 'Draw money so that each box has {0:number|numberFormat}p.',
  drawMoneyToMakeNumP: 'Draw money to make {0:number|numberFormat}p.',
  drawMoneyToMakeNumPounds: 'Draw money to make £{0:number|numberFormat}',
  drawNumCounters: 'Draw {0:string|lower} counter{{1:s}}.',
  drawNumCountersSharedIntoXEqualGroups:
    'Draw {0:number|numberFormat} counter{{0:s}} shared into {1:number|numberFormat} equal groups.',
  drawNumXForEachY: 'Draw {0:number|numberFormat} {1:string|lower} for each {2:string|lower}.',
  drawTheNextTwoShapesToCompleteThePattern: 'Draw the next two shapes to complete the pattern.',
  drawTheNextTwoShapesToContinueThePattern: 'Draw the next two shapes to continue the pattern.',
  drawX: 'Draw {0:string|lower}.',
  estimateTheNumberArrowPointingToTickAnswer:
    'Estimate the number the arrow is pointing to.<br/>Tick your answer.',
  fillInTheMissingNumber: 'Fill in the missing number.',
  hereAreSomeNumberBondsToX: 'Here are some number bonds to {0:number|numberFormat}',
  hereIsAQuarterOfAShapeCircleWhatTheWholeCouldLookLike:
    'Here is a quarter of a shape.<br/>Circle what the whole could look like.',
  howAreTheShapesSorted: 'How are the shapes sorted?',
  howMuchDoesCharHaveLeftTickYourAnswer: 'How much does {0} have left?<br/>Tick your answer.',
  howManyXAreThereTickYourAnswer: 'How many {0} are there?<br/>Tick your answer.',
  matchTheAdditionsToMultiplications: 'Match the additions to the multiplications.',
  matchTheAmounts: 'Match the amounts.',
  matchTheCorrectAnswersToTheCalculations: 'Match the correct answers to the calculations.',
  matchTheCorrectValueToTheCoins: 'Match the correct value to the coins.',
  matchTheCoinsToTheCorrectValue: 'Match the coins to the correct value.',
  matchTheCountersToTheCorrectValues: 'Match the counters to the correct values.',
  matchTheDoublesToAdditions: 'Match the doubles to the additions.',
  matchTheNotesToTheCorrectValues: 'Match the notes to the correct values.',
  matchTheNumbersToTheBaseTen: 'Match the numbers to the base 10',
  matchTheNumeralsToTheWords: 'Match the numerals to the words',
  matchTheNumbersToTheTallies: 'Match the numbers to the tallies.',
  matchThePicturesToTheStatements: 'Match the pictures to the statements.',
  matchThePictureToAStatement: 'Match the picture to a statement.',
  matchTheShapesToTheTurn: 'Match the shapes to the turn.',
  matchTheTalliesToTheNumbers: 'Match the tallies to the numbers.',
  matchTheTenFramesToTheNumberBonds: 'Match the ten frames to the number bonds.',
  matchTheXObjectToTheYObject: 'Match the {0:string|lower} to the {1:string|lower}.',
  matchTheTenFramesToTheSubtractions: 'Match the ten frames to the subtractions.',
  matchTheTimesToTheClocks: 'Match the times to the clocks.',
  matchTheWordsToThePictures: 'Match the words to the pictures.',
  measureTheLengthOfTheXObjectUsingARuler:
    'Measure the length of the {0:string|lower} using a ruler.',
  orderGlassesStartWithTheGreatestAmountVolume:
    'Order the glasses.<br/>Start with the greatest volume.',
  orderGlassesStartWithTheSmallestAmountVolume:
    'Order the glasses.<br/>Start with the smallest volume.',
  orderObjectsStartWithGreatestCapacity: 'Order the objects.<br/>Start with the greatest capacity.',
  orderObjectsStartWithSmallestCapacity: 'Order the objects.<br/>Start with the smallest capacity.',
  orderTheNumbersFromSmallestToGreatest: 'Order the numbers from smallest to greatest.',
  orderTheNumbersFromGreatestToSmallest: 'Order the numbers from greatest to smallest.',
  nameAHasNCountersNameBHasFewerCountersThanNameADrawCounters:
    '{nameA} has {numA:number|numberFormat} counter{{s}}.<br/>{nameB} has fewer counters than {nameA}.<br/>Draw counters to show how many counters {nameB} <b>could</b> have.',
  nameAHasNCountersNameBHasMoreCountersThanNameADrawCounters:
    '{nameA} has {numA:number|numberFormat} counter{{s}}.<br/>{nameB} has more counters than {nameA}.<br/>Draw counters to show how many counters {nameB} <b>could</b> have.',
  shadeAThirdOfTheGrid: 'Shade a third of the grid.',
  shadeAQuarterOfTheCircles: 'Shade a quarter of the circles.',
  shadeHalfOfTheCircles: 'Shade half of the circles.',
  shadeInXOfTheShape: 'Shade in {0} of the shape.',
  shadeTheCirclesToMakeArrayOfXRowsAndYColumns:
    'Shade the circles to make an array with {0:number|numberFormat} rows and {1:number|numberFormat} columns.',
  shadeTheCountersToShowTheMissingBondInThePattern:
    'Shade the counters to show the missing bond in the pattern.',
  shadeAQuarterOfTheGrid: 'Shade a quarter of the grid.',
  shadeInAQuarterOfTheShape: 'Shade in a quarter of the shape.',
  shadeThreeQuartersOfGrid: 'Shade three-quarters of the grid.',
  shareAllTheObjectsEquallyBetweenTrays:
    'Share all of the {0:string|lower} equally between the trays.',
  shareNumCountersEquallyBetweenTheNumBoxes:
    'Share {0:number|numberFormat} counters equally between the {1:string|lower} boxes.',
  sortTheActivitiesIntoTheTable: 'Sort the activities into the table.',
  sortTheCardsIntoTheTable: 'Sort the cards into the table.',
  sortTheFruitIntoGroups: 'Sort the fruit into groups.',
  sortTheNumbersIntoTheTable: 'Sort the numbers into the table.',
  sortTheObjectsIntoGroups: 'Sort the objects into groups.',
  sortTheShapesInOrderOfTheNumberOfSidesStartWithTheFewestNumberOfSides:
    'Sort the shapes in order of the number of sides.<br/>Start with the fewest number of sides.',
  sortTheShapesInOrderOfTheNumberOfSidesStartWithTheMostNumberOfSides:
    'Sort the shapes in order of the number of sides.<br/>Start with the most number of sides.',
  sortTheShapesInOrderOfTheNumberOfVerticesStartWithTheFewestNumberOfVertices:
    'Sort the shapes in order of the number of vertices.<br/>Start with the fewest number of vertices.',
  sortTheShapesInOrderOfTheNumberOfVerticesStartWithTheMostNumberOfVertices:
    'Sort the shapes in order of the number of vertices.<br/>Start with the most number of vertices.',
  theCapacityOfOneJugIsXCupsOfSandTickTheCapacityOfTwoJugs:
    'The capacity of 1 jug is {0:number|numberFormat} cups of sand.<br/>Tick the capacity of 2 jugs.',
  theCountersAreInOrderFromGreatestToSmallestDrawTheMissingCounters:
    'The counters are in order from greatest to smallest.<br/>Draw the missing counters.',
  theCountersAreInOrderFromSmallestToGreatestDrawTheMissingCounters:
    'The counters are in order from smallest to greatest.<br/>Draw the missing counters.',
  theDaysAreInOrderTickTheMissingDayOfTheWeek:
    'The days are in order.<br/>Tick the missing day of the week.',
  theDiagramShowsHalfAShapeAndALineOfSymmetryCompleteTheShape:
    'The diagram shows half a shape and a line of symmetry.<br/>Complete the shape.',
  theMassOfTheXObjectIsYAmountThanZCubesTickThePictureThatShowsThis:
    'The mass of the {0:string|lower} is {1:string|lower} {2:number|numberFormat} cube{{s}}.<br/>Tick the picture that shows this.',
  theNumbersAreAllInXTimesTableTickNumbersAlsoInYTimesTable:
    'The numbers are all in the {0:number|numberFormat} times-table.<br/>Tick the numbers that are also in the {1:number|numberFormat} times-table.',
  theItemMovesXSpacesDyDrawACrossOnTheTrack:
    'The {0:string|lower} moves {1:number|numberFormat} space{{s}} <b>{2:string|lower}</b>.<br/>Draw a cross to show where the {0:string|lower} is now.',
  theItemMovesXSpacesToTheDxDrawItOnTheTrack:
    'The {0:string|lower} moves {1:number|numberFormat} space{{s}} to the <b>{2:string|lower}</b>.<br/>Where is the {0:string|lower} now?<br/>Draw it on the track.',
  theItemMovesYSpacesDyAndXSpacesDxDrawACrossOnTheTrack:
    'The {item:string|lower} moves {dy:number|numberFormat} space{{s}} <b>{yDirection:string|lower}</b> and {dx:number|numberFormat} space{{s}} <b>{xDirection:string|lower}</b>.<br/>Draw a cross to show where the {item:string|lower} is now.',
  theTimeIsNumOClockDrawHandsOnTheClockToShowTimeInNumHours:
    "The time is {0} o'clock.<br/>Draw hands on the clock to show what time it will be in {1:number|numberFormat} hour{{s}}.",
  theXContainerIsYAmountDrawHowMuchJuiceCouldBeInTheXContainer:
    'The {0:string|lower} is {1:string|lower}.<br/>Draw how much juice could be in the {0:string|lower}.',
  theXObjectIsYWeightThanTheZObjectTickThePicture:
    'The {0:string|lower} is {1:string|lower} than the {2:string|lower}.<br/>Tick the picture that shows this.',
  threeChildrenRunARaceTickTheChildWhoComesFirst:
    'Three children run a race.<br/>Tick the child who comes first.',
  tickAllTheNumberBondsToNum: 'Tick <b>all</b> the number bonds to {0:number|numberFormat}',
  tickACardToCompleteTheComparison: 'Tick a card to complete the comparison.',
  tickDayOnWhichFewestXSold: 'Tick the day on which the <b>fewest</b> {0:string|lower} were sold.',
  tickDayOnWhichMostXSold: 'Tick the day on which the <b>most</b> {0:string|lower} were sold.',
  tickHowManyChildrenHaveNumPets: 'Tick how many children have {0:number|numberFormat} pet{{s}}.',
  tickHowManyFewerCarsAreXThanY:
    'Tick how many <b>fewer</b> cars are {0:string|lower} than {1:string|lower}.',
  tickHowManyMoreCarsAreXThanY:
    'Tick how many <b>more</b> cars are {0:string|lower} than {1:string|lower}.',
  tickTheAdditionsThatAreEqualToNum: 'Tick the additions that are equal to {0:number|numberFormat}',
  tickTheAdditionThatMatchTheBarModel: 'Tick the addition that matches the bar model.',
  tickTheAdditionThatMatchTheCounters: 'Tick the addition that matches the counters.',
  tickTheAdditionsThatMatchTheBarModel: 'Tick the additions that match the bar model.',
  tickTheAdditionsThatMatchTheCounters: 'Tick the additions that match the counters.',
  tickTheBase10ThatShowsX: 'Tick the base 10 that shows {0}',
  tickTheBoxesThatDoNotShowPoundXAndYPence:
    'Tick the boxes that <b> do not</b> show £{0:number|numberFormat} and {1:number|numberFormat}p.',
  tickTheBoxThatShowsPoundXAndYPence:
    'Tick the box that does shows £{0:number|numberFormat} and {1:number|numberFormat}p.',
  tickTheBoxesThatShowTheSameAmount: 'Tick the boxes that show the same amount.',
  tickTheBoxesThatShowX: 'Tick the box{{0:es}} that show{{0:s|}} {1:number|numberFormat}',
  tickTheContainerWithTheGreaterCapacity: 'Tick the container with the greater capacity.',
  tickTheContainerWithTheGreatestCapacity: 'Tick the container with the greatest capacity.',
  tickTheContainerWithTheSmallerCapacity: 'Tick the container with the smaller capacity.',
  tickTheContainerWithTheSmallestCapacity: 'Tick the container with the smallest capacity.',
  tickTheCorrectAnswer: 'Tick the correct answer.',
  tickTheCorrectNumberSentence: 'Tick the correct number sentence.',
  tickTheCorrectNumberSentences: 'Tick the correct number sentences.',
  tickTheDiagramsThatShow3Quarters: 'Tick the diagrams that show <frac n="3" d="4" />',
  tickTheDiceThatMakeX: 'Tick the dice that make {0:number|numberFormat}',
  tickTheGreatestAmountOfMoney: 'Tick the greatest amount of money.',
  tickTheGreatestNumber: 'Tick the greatest number.',
  tickTheGroupThatMatchesTheNumberOfChildren: 'Tick the group that matches the number of children.',
  tickTheGroupWithFewerObject: 'Tick the group with fewer {0:string|lower}.',
  tickTheGroupWithMoreObject: 'Tick the group with more {0:string|lower}.',
  tickTheHeavierObject: 'Tick the heavier object.',
  tickTheLighterObject: 'Tick the lighter object.',
  tickTheLongerObject: 'Tick the longer object.',
  tickTheLongerXObject: 'Tick the longer {0:string|lower}.',
  tickTheLongestPencil: 'Tick the longest pencil.',
  tickTheLongestRibbon: 'Tick the longest ribbon.',
  tickTheLongestTrain: 'Tick the longest train.',
  tickTheMissingNumberBondToX: 'Tick the <b>missing</b> number bond to {0:number|numberFormat}',
  tickTheNameOfTheShape: 'Tick the name of the shape.',
  tickTheNumberBondsToNum: 'Tick the number bonds to {0:number|numberFormat}',
  tickTheNumberOfEdges: 'Tick the number of edges.',
  tickTheNumberSentenceThatMatchesPicture: 'Tick the number sentence that matches the picture.',
  tickTheOrdinalShape: 'Tick the {0:string|lower} shape.',
  tickTheParts: 'Tick the parts.',
  tickThePopularPetLeast: 'Tick the least popular pet.',
  tickThePopularPetMost: 'Tick the most popular pet.',
  tickThePictureThatShowsEqualGroups: 'Tick the picture that shows <b>equal</b> groups.',
  tickThePictureThatShowsUnequalGroups: 'Tick the picture that shows <b>unequal</b> groups.',
  tickThePictureThatShowsXEqualGroupsOfY:
    'Tick the picture that shows {0:number|numberFormat} equal groups of {1:number|numberFormat}',
  tickThePicturesThatShowEqualGroups: 'Tick the pictures that show <b>equal</b> groups.',
  tickThePicturesThatShowUnequalGroups: 'Tick the pictures that show <b>unequal</b> groups.',
  tickTheSetsOfCountersThatCanBeSharedIntoTwoEqualGroups:
    'Tick the sets of counters that can be shared into 2 equal groups.',
  tickTheShapeThatIsCutIntoQuarters: 'Tick the {0} that is cut into quarters.',
  tickTheShapesThatAreCutIntoQuarters: 'Tick the {0} that are cut into quarters.',
  tickTheShapesWithACorrectVerticalLineOfSymmetry:
    'Tick the shapes with a correct vertical line of symmetry.',
  tickTheShapesWithAVerticalLineOfSymmetry: 'Tick the shapes with a vertical line of symmetry.',
  tickTheShortestFlower: 'Tick the shortest flower.',
  tickTheShorterObject: 'Tick the shorter object.',
  tickTheShorterXObject: 'Tick the shorter {0:string|lower}.',
  tickTheShortestPencil: 'Tick the shortest pencil.',
  tickTheShortestRibbon: 'Tick the shortest ribbon.',
  tickTheShortestTowerOfCubes: 'Tick the shortest tower of cubes.',
  tickTheShortestTrain: 'Tick the shortest train.',
  tickTheShortestTree: 'Tick the shortest tree.',
  tickTheSmallestAmountOfMoney: 'Tick the smallest amount of money.',
  tickTheSmallestNumber: 'Tick the smallest number.',
  tickTheStatementsThatAreTrue: 'Tick the statements that are true.',
  tickTheStatementsThatIsTrue: 'Tick the statement that is true.',
  tickTheTallerObject: 'Tick the taller object.',
  tickTheTallerXObject: 'Tick the taller {0:string|lower}.',
  tickTheTallestFlower: 'Tick the tallest flower.',
  tickTheTallestTowerOfCubes: 'Tick the tallest tower of cubes.',
  tickTheTallestTree: 'Tick the tallest tree.',
  tickTheXWeightObject: 'Tick the {0:string|lower} object.',
  tickTheMonthsThatHaveExactlyXDays:
    'Tick the months that have exactly {0:number|numberFormat} days.',
  tickTheShapesThatCompleteThePattern: 'Tick the shapes that complete the pattern.',
  tickTheShapeThatHasOneEqualPartShaded: 'Tick the shape that has 1 equal part shaded.',
  tickTheShapesThatFitThePattern: 'Tick the shapes that fit the pattern.',
  tickTheShapesThatHaveOneEqualPartShaded: 'Tick the shapes that have 1 equal part shaded.',
  tickTheTenFramesThatMakeX: 'Tick the ten frames that make {0:number|numberFormat}',
  tickTheTimeShown: 'Tick the time shown.',
  tickTheUnitFractions: 'Tick the unit fractions.',
  tickTheUnitFractionThatMatchesThePicture: 'Tick the unit fraction that matches the picture.',
  tickTheX: 'Tick the {0:string|lower}.',
  tickTheXObjectThatIsLeastCommon: 'Tick the {0:string|lower} that is least common.',
  tickTheXObjectThatIsMostCommon: 'Tick the {0:string|lower} that is most common.',
  tickWhatDayOfTheWeekTheXDateIsOn: 'Tick what day of the week the {0:string|lower} is on.',
  tickWhatTheShapeWillLookLikeAfterAXTurn:
    'Tick what the shape will look like after a <b>{0:string|lower}</b> turn.',
  tickWhatTheShapeWillLookLikeAfterAXTurnAntiClockwise:
    'Tick what the shape will look like after a <b>{0:string|lower}</b> turn anticlockwise',
  tickWhatTheShapeWillLookLikeAfterAXTurnClockwise:
    'Tick what the shape will look like after a <b>{0:string|lower}</b> turn clockwise.',
  tickWhatTheShapeWillLookLikeAfterAFullTurn:
    'Tick what the shape will look like after a <b>full</b> turn.',
  tickWhatTheShapeWillLookLikeAfterAHalfTurn:
    'Tick what the shape will look like after a <b>half</b> turn.',
  tickWhatTheShapeWillLookLikeAfterAQuarterTurn:
    'Tick what the shape will look like after a <b>quarter</b> turn.',
  tickWhatTheShapeWillLookLikeAfterAThreeQuarterTurn:
    'Tick what the shape will look like after a <b>three-quarter</b> turn.',
  tickYourAnswer: 'Tick your answer.',
  useACardToCompleteTheNumberSentence: 'Use a card to complete the number sentence.',
  useACardToCompleteSentence: 'Use a card to complete the sentence.',
  useCardsCompleteAddition: 'Use the cards to complete the addition.',
  useCardsCompleteMultiplication: 'Use the cards to complete the multiplication.',
  useCardsCompleteSentence: 'Use the cards to complete the sentence.',
  useCardsCompleteSentences: 'Use the cards to complete the sentences.',
  useCardsToCompleteNumberSentence: 'Use the cards to complete the number sentence.',
  useCardsToCompleteTheCalculations: 'Use the cards to complete the calculations.',
  useTheCardsToCompleteTheCount: 'Use the cards to complete the count.',
  useTheCardsToCompleteTheFractionPattern: 'Use the cards to complete the fraction pattern.',
  useTheCardsToCompleteTheNumberBondToX:
    'Use the cards to complete the number bond to {0:number|numberFormat}',
  useTheCardsToCompleteTheMultiplication: 'Use the cards to complete the multiplication.',
  useTheCardsToCompleteTheNumberSentence: 'Use the cards to complete the number sentence.',
  useTheCardsToCompleteTheNumberSentences: 'Use the cards to complete the number sentences.',
  useTheCardsToCompleteTheSentence: 'Use the cards to complete the sentence.',
  useTheCardsToCompleteTheSentences: 'Use the cards to complete the sentences.',
  useTheCardsToDescribeTheMovement: 'Use the cards to describe the movement.',
  useTheCardsToMakeA2DigitEvenNumber: 'Use the cards to make a 2-digit <b>even</b> number.',
  useTheCardsToMakeA2DigitOddNumber: 'Use the cards to make a 2-digit <b>odd</b> number.',
  useTheCardsToMakeTheAdditionCorrect: 'Use the cards to make the addition correct.',
  useTheCardsToMatchThePicturesToTheNumbers: 'Use the cards to match the pictures to the numbers.',
  useTheCardsToOrderTheHeights: 'Use the cards to order the heights.',
  useTheCardsToOrderTheLengths: 'Use the cards to order the lengths.',
  useTheCardsToOrderTheTemperature: 'Use the cards to order the temperature.',
  useTheCardsToPutThemInOrder: 'Use the cards to put them in order.',
  useTheCardsToSortTheShapes: 'Use the cards to sort the shapes.',
  useTheWordsToCompleteTheSentence: 'Use the words to complete the sentence.',
  whatIsTheXLengthOfTheYObjectInCubesTickYourAnswer:
    'What is the {0:string|lower} of the {1:string|lower} in cubes?<br/>Tick your answer.',
  whatIsTheNumberAsANumeralTickYourAnswer: 'What is the word as a numeral?<br/>Tick your answer.',
  whatIsTheNumeralAsANumberTickYourAnswer: 'What is the numeral as a word?<br/>Tick your answer.',
  whatIsTheWholeWriteTheNumber: 'What is the whole?<br/>Write the number.',
  whatIsXTickCorrectAnswer: 'What is {0}?<br/>Tick the correct answer.',
  whatSubtractionIsShownOnTheNumberLineUseTheCardsToCompleteTheNumberSentence:
    'What subtraction is shown on the number line?<br/>Use the cards to complete the number sentence.',
  whichTenFrameMatchesThePictureSelectYourAnswer:
    'Which ten frame matches the picture?<br/>Tick your answer.',
  writeHowTheShapesHaveBeenSortedChooseFromTheseCards:
    'Write how the shapes have been sorted.<br/>Choose from these cards.',
  writeLessThanGreaterThanOrEqualSymbolsToCompareTheCapacityOfTheContainers: `Write ${LESS_THAN}, ${GREATER_THAN} or = to compare the capacity of the containers.`,
  writeLessThanGreaterThanOrEqualSymbolsToCompare: `Write ${LESS_THAN}, ${GREATER_THAN} or = to compare.`,
  writeLessThanGreaterThanOrEqualSymbolsToCompareTheAmounts: `Write ${LESS_THAN}, ${GREATER_THAN} or = to compare the amounts.`,
  writeLessThanGreaterThanOrEqualSymbolsToCompareTheNumbers: `Write ${LESS_THAN}, ${GREATER_THAN} or = to compare the numbers.`,
  writeLessThanGreaterThanOrEqualSymbolsToCompareTheObjects: `Write ${LESS_THAN}, ${GREATER_THAN} or = to compare the objects.`,
  writeLessThanGreaterThanOrEqualSymbolsToCompareTheVolumes: `Write ${LESS_THAN}, ${GREATER_THAN} or = to compare the volumes.`,
  writeLessThanGreaterThanOrEqualSymbolsToMakeTheStatementCorrect: `Write ${LESS_THAN}, ${GREATER_THAN} or = to make the statement correct.`,
  writeMissingNumber: 'Write the missing number.',
  writeTheFractionsInTheCorrectColumn: 'Write the fractions in the correct column.',
  writeTheMissingPhrase: 'Write the missing phrase.',
  writeTheNameOfTheShape: 'Write the name of the shape.',
  writeTheNameOfTheShapeToCompleteTheSentence:
    'Write the name of the shape to complete the sentence.',
  writeNumbersInOrder: 'Write the numbers in order.',
  writeTwoDifferentMultiplicationsToMatchArray:
    'Write two different multiplications to match the array.',
  writeWhetherTheGroupsAreEqualOrUnequal: 'Write whether the groups are equal or unequal.',
  xContainerHasYMoreOrLessJuiceThanZContainerDrawHowMuchJuiceCouldBeInXContainer:
    '{0:string} {1:string} has {2:string|lower} juice than {0:string|lower} {3:string}.<br/>Draw how much juice could be in {0:string|lower} {3:string}.'
};
